<div class="image-container">
  <img [src]="imageSrc" (load)="onImageLoad($event)" [style.width.px]="width" style.height="auto">
  <canvas #canvasElement></canvas>
</div>
